var lib_core = require("lib-core");

var SchematicLabelTerminal = function () {
    lib_core.AbstractInstance.call(this);

    this.onInit(this, this.initialize);
};
lib_core.inherit(SchematicLabelTerminal, lib_core.AbstractInstance);
lib_core.JsonParser.registerClass(SchematicLabelTerminal, "SchematicLabelTerminal");

module.exports = SchematicLabelTerminal;

SchematicLabelTerminal.prototype.initialize = function () {
    var self = this;

    this.pos = this.shadow("pos",
        function(){
            return self.description().pos().rotate(self.parent().angle()).add(self.parent().pos());
        },
        null,
        [self.parent().pos, self.parent().angle, self.description]
    );

    this.angle = this.shadow("angle",
        function(){
            return (self.description().angle() + self.parent().angle()) % 360;
        },
        null,
        [self.parent().angle, self.description]
    );
};

 SchematicLabelTerminal.prototype.net = function() {
    if (this.parent()) {
        if (this.parent().parent()) {
            return this.parent().parent().schematicTerminalNetMap.get(this);
        }
    }
    return null;
 };
